import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'markant-platform-button-outline',
  standalone: true,
  templateUrl: './button-outline.component.html',
  styleUrl: './button-outline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule, MatButtonModule],
})
export class ButtonOutlineComponent {
  label = input.required<string>();
  disabled = input<boolean>(false);
  loading = input<boolean>(false);

  clicked = output();
}
